import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

export const useSwal = () => {
  const [t] = useTranslation("global");
  const Confirm = async(text) => {
    let Result;
    await Swal.fire({
      text: text,
      icon: "question",
      width: "20%",
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#dc3545",
      confirmButtonText: t("Accept"),
      cancelButtonText: t("Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        Result = true;
      } else {
        Result = false;
      }
    });
    return Result
  };

  const ConfirmTracking = async (text) => {
    let Result;
    await Swal.fire({
      position: "top-end",
      width: "20%",
      text: text,
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#dc3545",
      confirmButtonText: t("Confirm"),
      cancelButtonText: t("Decline"),
    }).then((result) => {
      if (result.isConfirmed) {
        Result = true;
      } else {
        if (result.dismiss === "backdrop") {
          Result = null;
        } else {
          Result = false;
        }
      }
    });
    return Result;
  };

  const CustomConfirmCancel = async (title, text, confirmButton, cancelButton) => {
    let Result;
    await Swal.fire({
      title: title,
      html:text,
      icon: 'warning',
      iconColor: "#dc3545",
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#dc3545",
      confirmButtonText: confirmButton,
      cancelButtonText: cancelButton,
    }).then((result) => {
      if (result.isConfirmed) {
        Result = true;
      } else {
        if(result.dismiss === "backdrop"){
          Result = null
        } else {
          Result = false;
        }
      }
    });
    return Result
  }

  const SuccessError = (icon, text, timer = 2000, LineBreak = false ) => {
    Swal.fire({
        position: 'top-end',
        width: 300,
        icon: icon,
        text: text,
        html: `<div style="white-space: pre-line;">${text}</div>`,
        showConfirmButton: false,
        timer: timer,
        backdrop: `
       rgba(0, 0, 0, 0.4)
         center
         no-repeat
        `
      })
  }

  const ConfirmTextArea = async () => {
    let Result = false;
    let Comment = null;
    const { value: text } = await Swal.fire({
      title: `<strong>${t("ReasonRejection")}</strong>`,
      icon: "warning",
      input: "textarea",
      inputPlaceholder: t("WriteCommentHere"),
      confirmButtonColor: "#198754",
      cancelButtonColor: "#dc3545",
      confirmButtonText: t("Accept"),
      cancelButtonText: t("Cancel"),
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return t("PleaseWriteComment");
        }
      },
    });

    if(text){
      Result = true
      Comment = text.trim()
    }

    return {Comment: Comment, Button: Result};
  };

  const CustomConfirmTextArea = async (
    title,
    textModal,
    confirmButton,
    cancelButton,
    inputValue,
    readonly
  ) => {
    let Result = false;
    let Comment = inputValue;
    const inputAttributes = readonly ? { readonly: true } : {};
    const { value: text, dismiss: dismiss } = await Swal.fire({
      title: title,
      html: textModal,
      icon: "warning",
      input: "textarea",
      showCancelButton: true,
      inputPlaceholder: t("WriteCommentHere"),
      inputValue: inputValue,
      inputAttributes: inputAttributes,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#dc3545",
      confirmButtonText: confirmButton,
      cancelButtonText: cancelButton,
      inputValidator: (value) => {
        if (!value) {
          return t("PleaseWriteComment");
        }
      },
    });
    if (text) {
      Result = true;
      Comment = text.trim();
    }
    if(dismiss === "backdrop"){
      Result = null
    }
    
    return { Comment: Comment, Button: Result };
  };

  return {
    Confirm,
    CustomConfirmCancel,
    SuccessError,
    ConfirmTextArea,
    CustomConfirmTextArea,
    ConfirmTracking
  };
};
